<template>
    <dialog-form
        :value="value"
        @input="$emit('input', $event)"
        @commit="save"
        :title="$localize('StopLicense.title')"
        :allow-continue="false"
        action="delete"
        :action-text="$localize('StopLicense.title')"
        >{{ $localize('StopLicense.message') }}</dialog-form
    >
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import sendCommand from '@/services/sendCommand'

export default {
    components: { DialogForm },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async save(callback) {
            const result = await sendCommand('StopLicense', {})

            if (result.success) {
                this.$emit('saved')
            }

            callback({ success: result.success })
        },
    },
}
</script>
